import BaseProxy from './base';

const apiUrlConf = {
  getActivityList: '/activities/list',
  getActivityDetail: '/activities/detail',
  getUsersByInvite: '/activities/getUsersByInvite',
  getUsersByTask: '/activities/getUsersByTask',
  getUsersByTaskMoney: '/activities/getUsersByTaskMoney',
  getUsersByInviteMoney: '/activities/getUsersByInviteMoney',
};

class Activity extends BaseProxy {
  async getActivityList(data) {
    const response = await this.submit('post', apiUrlConf.getActivityList, data);
    return response;
  }

  async getActivityDetail(data) {
    const response = await this.submit('post', apiUrlConf.getActivityDetail, data);
    return response;
  }

  async getUsersByInvite(data) {
    const response = await this.submit('post', apiUrlConf.getUsersByInvite, data);
    return response;
  }

  async getUsersByTask(data) {
    const response = await this.submit('post', apiUrlConf.getUsersByTask, data);
    return response;
  }

  async getUsersByTaskMoney(data) {
    const response = await this.submit('post', apiUrlConf.getUsersByTaskMoney, data);
    return response;
  }

  async getUsersByInviteMoney(data) {
    const response = await this.submit('post', apiUrlConf.getUsersByInviteMoney, data);
    return response;
  }
}
const ActivityProxy = new Activity();
export default ActivityProxy;
